<div class="row">
  <div class="col-4">
    <sb-card>
      <div card-body classes="d-flex flex-grow-1 w-100" *ngIf="channel" class="flex-grow-1 w-100">
        <h5 class="mb-2">{{'lang.channels.channelInformation' | translate}}</h5>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-dark-75 font-weight-bolder">{{'lang.globals.logo' | translate}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <div class="image-video-wrapper">
            <ng-container *ngIf="permissionService.hasPermission(permissionService.Permission.channel_edit); else noChannelEdit">
              <div (click)="pickLogo()" class="userPic cursor-pointer" [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''">
                <div class="userPicEdit">
                  <sb-icon class="icon-center" icon="edit"></sb-icon>
                </div>
              </div>
            </ng-container>
            <ng-template #noChannelEdit>
              <div class="userPic" [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''">
              </div>
            </ng-template>

          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-dark-75 font-weight-bolder">{{'lang.channels.channelName' | translate}}</span>
        </div>
        <div class="form-group">
          <input class="form-control"
                 [disabled]="channel?.locked || !permissionService.hasPermission(permissionService.Permission.channel_edit)"
                 [(ngModel)]="channel.name" (ngModelChange)="emitChange()" type="text"/>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-dark-75 font-weight-bolder">{{'lang.channels.channelDescription' | translate}}</span>
        </div>
        <div class="form-group">
          <input class="form-control"
                 [disabled]="channel?.locked || !permissionService.hasPermission(permissionService.Permission.channel_edit)"
                 [(ngModel)]="channel.description" (ngModelChange)="emitChange()" type="text"/>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-dark-75 font-weight-bolder">{{'lang.channels.markersCount' | translate}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-muted"><a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.channelDetailsMarker"
                                      [sbRouterLink]="util.RoutingID.channelDetailsMarker">{{(channel && channel?.markers) ? channel?.markers?.length : ''}}
            Markers</a></span>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="text-dark-75 font-weight-bolder">{{'lang.channels.options' | translate}}</span>
        </div>
        <div class="row">
          <div class="col">
            <small *ngIf="!channel.locked" class="red">
              <sb-icon icon="lockOpen"></sb-icon>&nbsp;&nbsp;{{'lang.mediumExplorer.notReadyUse' | translate}}
            </small>
            <small *ngIf="channel.locked" class="green">
              <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{'lang.mediumExplorer.readyUse' | translate}}
            </small>
          </div>
        </div>
        <div *ngIf="!channel.locked" class="d-flex justify-content-between mb-2">
          <button *ngPermissions="permissionService.Permission.channel_lock" [disabled]="!channel.name || channel?.name?.length === 0"
                  (click)="lockChannel()"
                  class="btn btn-success w-100 mr-1">
            <sb-icon icon="lockClosed"></sb-icon>
            {{'lang.mediumExplorer.setReady' | translate}}
          </button>
          <button *ngPermissions="permissionService.Permission.channel_delete" (click)="deleteChannel()"
                  class=" btn btn-danger w-100 ml-1">
            <sb-icon icon="trash"></sb-icon>
            {{'lang.channels.deleteChannel' | translate}}
          </button>
        </div>
      </div>
    </sb-card>
  </div>

  <div class="col-8">
    <sb-card>
      <div card-fit class="overflow-hidden header-wrapper" style="position: relative;">
        <div class="userPicEdit userPicEditFar cursor-pointer" (click)="pickAmbiance()">
          <sb-icon class="icon-center" icon="edit"></sb-icon>
        </div>
        <img style="object-fit: cover; height: auto; width: 100%;" [src]="ambianceUrl"/>
      </div>
    </sb-card>
  </div>
</div>
